import React from 'react'
import s from './reportExcel.module.css'

type Props = {
  fileName: string
  item: (number[] | (string | null)[])[]
}

const CsvExport: React.FC<Props> = ({ fileName, item }) => {
  const exportCsvFile = (): void => {
    if (!item || item.length === 0) return

    const rowCount = item[0].length
    const rows: string[] = []

    for (let i = 0; i < rowCount; i++) {
      const row = item.map(col => {
        const val = col[i]
        if (val === null || val === undefined) return ''
        return `"${String(val)}"` // оборачиваем, чтобы Excel не ломал даты/текст
      })
      rows.push(row.join(';') + ';;;;;') // добавляем 5 пустых колонок
    }

    const csvContent = '\uFEFF' + rows.join('\n') // BOM для кириллицы

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = `${fileName}.txt.csv`
    anchor.click()
    window.URL.revokeObjectURL(url)
  }

  return (
    <div className={s.btnExport}>
      <button
        className={s.buttonExport}
        onClick={exportCsvFile}
      >
        Скачать {fileName}
      </button>
    </div>
  )
}

export default CsvExport
